import _ from 'lodash';

const MONITOR_LEVEL = {
  ERROR: 1,
  WARN: 2,
  INFO: 3,
};

export const MONITOR_CODE_TYPE = {
  API_CURL: 'API_CURL', // 接口CURL信息
  API_REQ: 'API_REQ', // 接口请求前的信息
  API_SUCCESS: 'API_SUCCESS', // 接口成功 一般情况下成功不需要上传
  API_FAILED: 'API_FAILED', // 接口失败
  API_AUTH_ERR: 'API_AUTH_ERR', // 未登录
  FETCH_FAILED: 'FETCH_FAILED', // 请求函数失败

  RESOURCE_ERR: 'RESOURCE_ERR', // 资源加载错误上报
  EXPOSURE: 'EXPOSURE', // 关键DOM元素曝光，酌情使用
  TRY_CATCH_ERR: 'TRY_CATCH_ERR', // 捕获到异常上报
};

export interface ILogParams {
  code?: string;
  eventName: string;
  msg?: any;
}

// 忽略上报的CODES
const IGNORE_CODES = new Set([MONITOR_CODE_TYPE.API_CURL]);

const isIgnore = (params: ILogParams) => IGNORE_CODES.has(params?.code || params?.eventName);

const processParams = (params: ILogParams): ILogParams => {
  if ((params?.code || params?.eventName) === MONITOR_CODE_TYPE.API_SUCCESS) {
    params.msg = _.pick(params, ['functionId', 'requestId', 'XApiRequestId', 'traceId']);
  }

  return params;
};

const logMessage = (type: number, params: ILogParams) => {
  try {
    const code = params?.code || params?.eventName;
    if (!params || !code) return;
    if (isIgnore(params)) return;
    params = processParams(params); // 进行参数二次处理
    const customLogger = (window as any)?.__sgm__?.custom;
    if (typeof customLogger === 'function') {
      customLogger({
        type,
        code: code,
        msg: params.msg ?? '',
      });
    }
  } catch (e) {}
};

const errorLog = (params: ILogParams) => logMessage(MONITOR_LEVEL.ERROR, params);
const warningLog = (params: ILogParams) => logMessage(MONITOR_LEVEL.WARN, params);
const infoLog = (params: ILogParams) => logMessage(MONITOR_LEVEL.INFO, params);

const sgmManager = {
  errorLog,
  warningLog,
  infoLog,
};

export default sgmManager;
